// Shared constants for the OWARE partner perk.
//
// OWARE = Owner Awareness — daily financial monitoring, owner-awareness
// reporting, and fraud alerts for the practice. Bundled free with every
// medical_practice MediLink subscription.
//
// Sign-up flow: MediLink subscribers create their OWARE account through the
// referral link below. The `ref` code attributes them to MediLink. What
// happens on Oware's side after that — whether the included tier is applied
// automatically or someone there provisions it — is not something this repo
// can see, so don't make promises about it in user-facing copy.
//
// The previous Statra-hosted path (secure.statra.com/onboarding/medilink/…)
// died when Statra rebranded to Oware; that URL now 404s. Replaced
// 2026-08-28 with the referral link the Oware team supplied.
//
// Used by:
//   * components/billing/Onboarding.js — post-checkout welcome handoff
//   * components/billing/BillingSettings.js — "Included" perk tile
//   * server/src/services/email.js — keeps its own copy for the OWARE
//     announcement email; update both together.

export const OWARE_URL = 'https://secure.oware.com/welcome/link?ref=10W80V9C9AD9ANKB';
